export const PractitionerScheduleEntryBlockedType: {
    BREAK: "BREAK",
    VACATION: "VACATION",
    MEETING: "MEETING",
    SICK_LEAVE: "SICK_LEAVE",
    EDUCATION: "EDUCATION",
    OTHER: "OTHER",
} = {
    BREAK: "BREAK",
    VACATION: "VACATION",
    MEETING: "MEETING",
    SICK_LEAVE: "SICK_LEAVE",
    EDUCATION: "EDUCATION",
    OTHER: "OTHER",
};

export type PractitionerScheduleEntryBlockedType = (typeof PractitionerScheduleEntryBlockedType)[keyof typeof PractitionerScheduleEntryBlockedType]